import React from 'react'
import { Box, Paper, Stack, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'

// Headline number. Clickable when `onClick` is given (used as a filter);
// `active` highlights the selected one. `tone` is a hex accent colour.
const StatTile = ({
  label,
  value,
  caption,
  icon,
  tone = '#239AA4',
  active = false,
  onClick,
  sx,
}) => (
  <Paper
    elevation={0}
    component={onClick ? 'button' : 'div'}
    type={onClick ? 'button' : undefined}
    onClick={onClick}
    aria-pressed={onClick ? active : undefined}
    sx={{
      p: 2,
      height: '100%',
      width: '100%',
      textAlign: 'left',
      border: '1px solid',
      borderColor: active ? tone : '#E2E8F0',
      borderRadius: 3,
      bgcolor: active ? alpha(tone, 0.08) : '#FFFFFF',
      cursor: onClick ? 'pointer' : 'default',
      transition: 'border-color 150ms ease, background-color 150ms ease, box-shadow 150ms ease',
      fontFamily: 'inherit',
      boxSizing: 'border-box',
      '&:hover': onClick ? { boxShadow: '0 4px 14px rgba(15,23,42,0.08)' } : undefined,
      '&:focus-visible': { outline: `2px solid ${tone}`, outlineOffset: 2 },
      ...sx,
    }}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={1}>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
        }}
      >
        {label}
      </Typography>
      {icon && (
        <Box
          sx={{
            width: 30,
            height: 30,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: alpha(tone, 0.12),
            color: tone,
            flexShrink: 0,
            '& svg': { fontSize: 18 },
          }}
        >
          {icon}
        </Box>
      )}
    </Stack>
    <Typography variant="h4" fontWeight={700} color="text.primary" lineHeight={1.2} marginTop={0.5}>
      {value ?? '…'}
    </Typography>
    {caption && (
      <Typography variant="caption" color="text.secondary" display="block" marginTop={0.25}>
        {caption}
      </Typography>
    )}
  </Paper>
)

export default StatTile
